import React from "react";
// also exported from '@storybook/react' if you can deal with breaking changes in 6.1
import { getEmptyDataDefinition, getFilledDataDefinition } from "../rule-engine-core/Common/Data/DataTestData";
import { getFamilyAddress, getOnePersonWithFriends } from "../CommonUI/DataEditing/Testing/TestData";
import { DataBuilder } from "./DataBuilder";
import { FileDataDefinition } from "../rule-engine-core/Common/Data/Definitions/FileDataDefinition";
import { StoryNode } from "../CommonUI/StoryBook/StoryData";

export const DataDefinitionEditorStories = [
    new StoryNode(
        () => {
            let def = getEmptyDataDefinition();
            return <DataBuilder definition={def}></DataBuilder>;
        },

        "Shared",
        "Data Designer",
        "Designer",
        "Empty",
    ),

    new StoryNode(
        () => {
            let def = getFilledDataDefinition();

            return <DataBuilder definition={def}></DataBuilder>;
        },

        "Shared",
        "Data Designer",
        "Designer",
        "With Data",
    ),
    new StoryNode(
        () => {
            let def = getFilledDataDefinition();
            let filedef = new FileDataDefinition();
            filedef.name = "photo";
            def.fields.push(filedef);

            return <DataBuilder definition={def}></DataBuilder>;
        },

        "Shared",
        "Data Designer",
        "Designer",
        "With File",
    ),
    new StoryNode(
        () => {
            let def = getFilledDataDefinition();
            let samedef = new FileDataDefinition("person");
            def.fields.push(samedef);

            return <DataBuilder definition={def}></DataBuilder>;
        },

        "Shared",
        "Data Designer",
        "Designer",
        "Duplicated Fields",
    ),
    new StoryNode(
        () => {
            let def = getFilledDataDefinition();
            let emptyfield = new FileDataDefinition();
            def.fields.push(emptyfield);

            return <DataBuilder definition={def}></DataBuilder>;
        },

        "Shared",
        "Data Designer",
        "Designer",
        "No Name Field",
    ),
    new StoryNode(
        () => {
            let def = getFilledDataDefinition();

            return (
                <DataBuilder
                    definition={def}
                    readOnly={true}
                ></DataBuilder>
            );
        },

        "Shared",
        "Data Designer",
        "Designer",
        "Readonly",
    ),
    new StoryNode(
        () => {
            let def = getOnePersonWithFriends();

            return <DataBuilder definition={def}></DataBuilder>;
        },

        "Shared",
        "Data Designer",
        "Designer",
        "With Friends",
    ),
    new StoryNode(
        () => {
            let def = getFamilyAddress();

            return <DataBuilder definition={def}></DataBuilder>;
        },

        "Shared",
        "Data Designer",
        "Designer",
        "Family Address",
    ),
];
